export { default as withDNDContext } from './withDNDContext';
export { injectDNDSubblocks } from './DNDSubblocks';
export { default as SubblocksEdit } from './SubblocksEdit';
export { default as SubblockEdit } from './SubblockEdit';
export { default as SubblocksWrapper } from './SubblocksWrapper';
export { default as Subblock } from './Subblock';

const applyConfig = (config) => config;
export default applyConfig;